import { SpecialConditionFilters } from '@reliance/types/filters/SpecialConditionFilters';
import { SpecialCondition } from '@reliance/types/models/SpecialCondition';
import { useAsync, type UseAsyncReturn } from 'react-async-hook';
import api from '../common/api';
import { PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';

/** GET /condition (paginated): same metadata as {@link PaginatedResponse} but list key is `results`, not `data`. */
export type SpecialConditionsPaginatedResponse = Omit<
  PaginatedResponse<SpecialCondition>,
  'data' | 'supportingData'
> & {
  results: SpecialCondition[];
};

export type SpecialConditionListFilters = Omit<SpecialConditionFilters, 'raw'>;

export function useSpecialConditions(
  filters?: SpecialConditionListFilters
): UseAsyncReturn<SpecialConditionsPaginatedResponse, [SpecialConditionListFilters | undefined]> {
  return useAsync<SpecialConditionsPaginatedResponse, [SpecialConditionListFilters | undefined]>(
    () =>
      api.get<SpecialConditionsPaginatedResponse>(`/condition`, { params: filters }).then((r) => r.data),
    [filters]
  );
}

export function useSpecialConditionsWithoutPagination(
  filters?: SpecialConditionListFilters
): UseAsyncReturn<SpecialCondition[], [SpecialConditionListFilters | undefined]> {
  return useAsync(
    () =>
      api.get<SpecialCondition[]>(`/condition`, {
        params: { ...(filters ?? {}), raw: true },
      }).then((r) => r.data),
    [filters]
  );
}
